import { render } from "./PdpLrpList.vue?vue&type=template&id=071aadb8"
import script from "./PdpLrpList.vue?vue&type=script&lang=js"
export * from "./PdpLrpList.vue?vue&type=script&lang=js"

import "./PdpLrpList.vue?vue&type=style&index=0&id=071aadb8&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__